/** @jsxImportSource preact */
import { useSignal, effect } from '@preact/signals'
import Field from "./components/field.tsx";
import {settings_regular, settings_event, settings_print} from "./settings";

function UserCreate() {
    var formErrors, recaptchaError, loginUrl, postData, csrftoken,  purchase

    formErrors = JSON.parse(document.getElementById('form-errors')?.textContent || '{}')
    postData = JSON.parse(document.getElementById('post-data')?.textContent || '{}')
    loginUrl = document.getElementById('login-url')?.textContent || ''
    recaptchaError = JSON.parse(document.getElementById('recaptcha-error')?.textContent || null)
    csrftoken = JSON.parse(document.getElementById('csrf')?.textContent || '{}')
    purchase = JSON.parse(document.getElementById('purchase-type')?.textContent || '{}')

    const settings = useSignal(settings_regular)
    if(purchase.type == 'event') settings.value = settings_event
    if(purchase.type == 'print') settings.value = settings_print

    const qParams = new URLSearchParams(location.search);
    const gasperClick = async () => {
        await fetch('https://sgtm.delo.si/gtag/js?id=G-SBSLCX0C5Z')
    }

    return <>

        {qParams.get('gasper') == 'true' && <button className="waves-effect waves-light blue darken-3 btn" onClick={gasperClick}>
            Klic na sgtm.delo.si/gtag
        </button>}

        {purchase.type == 'event' &&
            <div className="row wrapper_a">
                Pred nakupom se registrirajte in si ustvarite svoj uporabniški račun.
                Če ga že imate, kliknite spodaj na »Prijavite se«.
            </div>
        }
        <form className="col s12" action={location.href} method="post">
            <input type="hidden" name="csrfmiddlewaretoken" value={csrftoken.csrf}/>
            <input type="hidden" name="purchase_type" value={purchase.type||'normal'}/>
            <div className={'row wrapper_a'}>
                <div className="col s12">
                    <h2 className="h2-section-title">
                        Ustvarite uporabniški račun
                    </h2>
                </div>
                {settings.value.map((item: any, i: number) => <Field i={i} data={item}
                                                                     tools={{formErrors, postData, settings}}/>)}

                <div className="input-field col s12">
                    {/* Recaptcha */}
                    <script src='https://www.google.com/recaptcha/api.js?hl=sl'></script>
                    <div className="g-recaptcha" data-sitekey="6Ldh3QwTAAAAALxNTS2jOZhNTHLMFJTHJGhHm487"></div>
                    {Boolean(recaptchaError) &&
                        <ul className="errorlist">
                            <li>{recaptchaError}</li>
                        </ul>
                    }
                </div>

                <div className="input-field col s12">
                    <button className="waves-effect waves-light blue darken-3 btn" type="submit" name="user_create">
                        Ustvari uporabnika
                    </button>
                </div>

                <div className="ella2_login__create col s12">
                    Že imate račun? <a href={loginUrl} className="blue-text darken-3">Prijavite
                    se: <i className="fas fa-user"></i></a>
                </div>
            </div>
        </form>
    </>
}

export default UserCreate